const config = import.meta.env;
const authApiUrl = config.VITE_APP_AUTH_API_URL || "https://auth.7baggers.com/";
const tickerApiUrl =
  config.VITE_APP_TICKER_API_URL || "https://tickers.7baggers.com/";
const priceApiUrl =
  config.VITE_APP_PRICE_API_URL || "https://prices.7baggers.com/";
const edgarApiUrl =
  config.VITE_APP_EDGAR_API_URL || "https://edgar.7baggers.com/";
const apiUrl = config.VITE_APP_API_URL || "https://api.stockideashq.com/api/";
const ga4Id = config.VITE_APP_GA4_ID;
const apiUrlSSR =
  config.VITE_APP_API_URL_SSR || "http://api-unsecure.stockideashq.com/api/";

export default {
  apiUrl,
  apiUrlSSR,
  ga4Id,
  isProd: config.VITE_IS_PROD,
  datadogAppId: config.VITE_APP_DATADOG_APP_ID,
  datadogClientToken: config.VITE_APP_DATADOG_CLIENT_TOKEN,
  googleClientId: config.VITE_APP_GOOGLE_CLIENT_ID,
  googleAnalyticsId: config.VITE_APP_GOOGLE_ANALYTICS_ID,
  getAuthApiUrl: () => {
    return authApiUrl;
  },
  getTickerApiUrl: () => {
    return tickerApiUrl;
  },
  getPriceApiUrl: () => {
    return priceApiUrl;
  },
  getEdgarApiUrl: () => {
    return edgarApiUrl;
  },
  getApiUrl: () => {
    if (import.meta.env.SSR) {
      return apiUrlSSR;
    } else {
      return apiUrl;
    }
  },
};
